export default {
  action: {
    addReceipt: 'Beleg anhängen',
    approve: 'Genehmigen',
    attach: 'Anheften',
    back: 'Zurück',
    companyReports: 'Unternehmensberichte',
    cancelRequest: 'Anfrage zurückziehen',
    cardTransfer: 'Betrag zurücküberweisen',
    chooseEmailed: 'Wähle Email-Beleg',
    close: 'Schließen',
    connectXero: 'Mit Xero verbinden',
    createBudget: 'Neues Budget erstellen',
    decline: 'Ablehnen',
    delete: 'Löschen',
    deleteBudget: 'Budget löschen',
    discard: 'Abbrechen',
    disconnectXero: 'Verbindung mit Xero trennen',
    faq: 'FAQ',
    forgotPassword: 'Passwort vergessen?',
    funds: 'Gelder',
    hideInactiveBudgets: 'Alte Budgets ausblenden',
    inviteUsers: 'Nutzer einladen',
    manage: 'Verwalten',
    open: 'Öffnen',
    openFile: '{file} öffnen',
    pendingRequests: 'Ausstehende Anfragen',
    register: 'Registrieren',
    report: 'Bericht',
    requests: 'Anfragen',
    returnUnspent: 'Ungenutztes Geld ({amount}) zurückgeben',
    save: 'Speichern',
    saveChanges: 'Speichern',
    searchCategory: 'Nach Kategorie suchen',
    searchRequest: 'Nach Anfrage suchen',
    selectCategory: 'Kategorie auswählen',
    selectRequest: 'Anfrage auswählen',
    sendEmailReport: 'Bericht per Email senden',
    sendXeroReport: 'Nach Xero exportieren',
    showInactiveBudgets: 'Alte Budgets anzeigen',
    selectFile: 'Datei wählen',
    settings: 'Einstellungen',
    signIn: 'Einloggen',
    submitRequest: 'Anfrage absenden',
    tagCategory: 'Kategorie wählen',
    tagRequest: 'Anfrage wählen',
    takePicture: 'Foto machen',
    thisBudget: 'Dieses Budget',
    transfer: 'Überweisen',
    transferFromBudget: 'Von diesem Budget überweisen',
    transferToBudget: 'Zu diesem Budget überweisen',
    topUpCard: 'Karte aufladen',
    updateCard: 'Zahlungsart aktualisieren',
    viewReceipt: 'Beleg anzeigen',
    viewRequests: 'Anfragen anzeigen',
    videoTutorials: 'Video Anleitungen'
  },
  dialog: {
    cancelRequest: 'Sind Sie sicher, dass Sie diese Anfrage zurückziehen möchten?',
    cardTopup: '{user}\'s Karte wurde mit {amount} von "{budget}" aufgeladen.',
    createReportSuccess: 'Der Bericht wurde erfolgreich erstellt. Sie werden eine Email mit Links zu den Dokumenten erhalten.',
    createXeroReportSuccess: 'Der Xero Report wurde erstellt und sollte in den nächsten 5 Minuten in Xero erscheinen.',
    deleteBudget: 'Sind Sie sicher, dass Sie dieses Budget löschen möchten?',
    deleteReceipt: 'Sind Sie sicher, dass Sie die Quittung löschen möchten?',
    makeRequestSuccess: 'Neue Anfrage wurde erfolgreich erstellt.',
    paymentDetails: 'Sie müssen eine gültige Zahlungsart hinterlegen, bevor Sie zusätzliche Nutzer einladen können.',
    recall: 'Es wurden {amount} von {user} Karte zurücküberwiesen.',
    saveChanges: 'Wollen Sie die Änderungen speichern?',
    supportError: 'Verzeihung, aber es ist ein Fehler aufgetreten: {error}. Bitte schicken Sie Ihre Anfragen an support@getaio.co.uk.'
  },
  label: {
    accountNo: 'Kontonr.',
    activeUsers: 'Keine aktiven Nutzer | Ein aktiver Nutzer | {count} aktive Nutzer',
    actualSpend: 'Tatsächliche Ausgaben',
    all: 'Alle',
    allocated: 'Erhalten',
    addNote: 'Mitteilung',
    address: 'Adresse',
    approved: 'Genehmigt',
    amount: 'Betrag',
    balance: 'Saldo',
    budget: 'Budget | Budgets',
    budgetFrom: 'Von Budget',
    budgetFilter: 'Budget-Filter',
    by: 'von {user} am {date}',
    cardBrand: 'Marke/Typ',
    cardDetails: 'Aktuelle Zahlungsart',
    cardExpires: 'Gültig bis',
    cardNumber: 'Nummer',
    category: 'Kategorie',
    declined: 'Abgelehnt',
    description: 'Beschreibung',
    dob: 'Geburtsdatum',
    email: 'E-Mail',
    english: 'Englisch',
    expiresEnd: 'GÜLTIG BIS',
    faceId: 'FaceID Authentifizierung',
    fingerprint: 'Fingerabdruck Authentifizierung',
    firstName: 'Vorname',
    from: 'Von',
    german: 'Deutsch',
    kybStatus: 'KYB Status',
    language: 'Sprache',
    lastName: 'Nachname',
    lastTransaction: 'Letzte Ausgabe',
    location: 'Ort',
    managedBy: 'Verwaltet von',
    monthYear: 'MONAT/JAHR',
    name: 'Name',
    notes: 'Notizen',
    password: 'Passwort',
    pendingApproval: 'Genehmigung ausstehend',
    processedBy: '{decision} von {user} am {date}',
    processedOn: '{decision} am {date}',
    phone: 'Telefon',
    postcode: 'PLZ',
    reason: 'Begründung',
    receipt: 'Quittung',
    reference: 'Referenz',
    refunded: 'Rückerstattet',
    registrationNo: 'Registrierungsnummer',
    request: 'Anfrage',
    requested: 'Angefragt',
    requestFrom: 'Anfrage von',
    returned: '{amount} wurden rückerstattet',
    showPending: 'ausstehende anzeigen',
    showProcessed: 'abgeschlossene anzeigen',
    sortCode: 'BLZ',
    spendReason: 'Grund für die Anfrage',
    spent: 'Ausgegeben',
    subject: 'Betreff',
    to: 'Nach',
    toDate: 'Bis',
    touchId: 'TouchID Authentifizierung',
    user: 'Nutzer | Nutzer',
    userAccess: 'Nutzer mit Zugang',
    xeroBankAccount: 'Xero Bankkonto',
    xeroChartAccounts: 'Kontenplan',
    xeroOrganisation: 'Xero Organisation'
  },
  menu: {
    budgets: 'Budgets',
    company: 'Organisation',
    help: 'Hilfe',
    logout: 'Ausloggen',
    myCard: 'Meine Karte',
    myProfile: 'Mein Profil',
    myRequests: 'Meine Anfragen',
    myTransactions: 'Meine Ausgaben',
    reports: 'Berichte',
    requests: 'Anfragen',
    settings: 'Einstellungen',
    spend: 'Ausgaben',
    users: 'Nutzer'
  },
  option: {
      budgetReport: 'Budget-Bericht',
      cardIssue: 'Problem mit der Karte',
      expenseReport: 'Ausgaben-Bericht',
      generalSuggestion: 'Generelles Problem',
      month: 'Monat',
      other: 'Other',
      stylingIssue: 'Grafisches Problem',
      technicalIssue: 'Technisches Problem',
      xeroReport: 'Xero-Bericht',
      year: 'Jahr'
    },
  placeholder: {
    chooseBudget: 'Bitte Budget auswählen',
    chooseUser: 'Bitte Nutzer auswählen',
    email: 'Ihre E-Mail-Adresse',
    enterEmail: 'E-Mail-Adresse eingeben',
    enterMessage: 'Mitteilung an Nutzer eingeben',
    enterComment: 'Kommentar eingeben',
    enterNotes: 'Notizen eintippen',
    password: 'Ihr Passwort'
  },
  text: {
    amountOnCard: 'Das Saldo auf {user} Karte beträgt {balance}. Wieviel davon möchten Sie zurücküberweisen?',
    bankTransfer: 'Sie können Geld per Banküberweisung auf Ihr aio* Organisations-Konto transferieren:',
    budgetReport: 'Der Budget-Bericht beinhaltet alle Transaktionen in und aus \'{name}\' während des gewählten Zeitraums.',
    expenseReport: 'Der Ausgaben-Bericht beinhaltet alle Karten-Transaktionen aller Nutzer in der Organisation während des gewahlten Zeitraums.',
    forwardEmail: [
      'Sie können auch Emails an ',
      ' weiterleiten.'
    ],
    noManageRequests: 'Keiner in Ihrem Team hat bisher eine Geld-Anfrage gestellt. Sobald dies der Fall ist, erhalten Sie eine Benachrichtigung und die Anfrage wird hier erscheinen.',
    noMyRequests: [
      'Sie haben noch keine Geld-Anfrage gestellt. Klicken Sie auf + um jetzt eine',
      'Anfrage zu stellen.',
      ''
    ],
    noSpend: 'Sie haben noch kein Geld mit Ihrer aio* Karte ausgegeben. Sobald Sie mit Ihrer aio* Karte bezahlen, werden Sie eine Mitteilung erhalten und getätigte Transaktionen werden hier erscheinen.',
    pendingCard: `<b>Sobald Sie Ihre neue Karte erhalten, bitte aktivieren Sie diese und bestätigen Sie Ihre PIN:</b><br>
      <ul>
        <li>Dafür rufen Sie diese Nummer an: (+44) 02034755351</li>
        <li>Wählen Sie 1</li>
        <li>Wählen Sie Option 1</li>
        <li>Folgen Sie den Anweisungen, um Ihre Karte zu aktivieren (dafür benötigen Sie die 16-stellige Kartennummer und Ihr 6-stelliges Geburtsdatum als Passwort im Format TTMMJJ)</li>
      </ul>
      <br>
      <b>So bestätigen Sie Ihre PIN:</b><br>
      <ul>
        <li>Rufen Sie den Kartendienst unter (+44) 02034755351 an</li>
        <li>Wählen Sie 1</li>
        <li>Wählen Sie Option 4</li>
        <li>Geben Sie Ihre 16-stellige Kartennummer ein</li>
        <li>Geben Sie Ihr Passwort ein (Ihr 6-stelliges Geburtsdatum - TTMMJJ)</li>
      </ul>
      <br>Sie können Ihre PIN an jedem Geldautomaten ändern, der diesen Dienst anbietet.`,
    price: '<strong>5£</strong> pro aktivem Nutzer pro Monat',
    unclassifiedExpenses: '{count} Transaktionen haben keine Kategorie. Künftige Transaktionen werden in Xero hinzugefügt, aber Änderungen an Existierenden können nicht übernommen werden.',
    validPayment: 'Wir benötigen ein gültiges Zahlungsmittel für die Herausgabe von neuen aio* Karten und für die Erhebung von Nutzungsgebühren.',
    verifying: [
      'Wir überprüfen die Registrierung Ihrer Organisation. Wenn der Prozess abgeschlossen ist, werden wir Sie informieren und Sie können Geld auf Ihr aio* Konto überweisen.',
      'In der Zwischenzeit können Sie ja schon Ihre Teammitglieder auf der \'Nutzer\'-Seite (\'Organisation\') einladen. Einladungen zur Registrierung werden dann per Email versendet. Nach der persönlichen Datenerfassungen sind wir in der Lage aio* Karten zu verschicken.'
    ],
    xeroChartAccounts: 'Der Kontenplan von Xero wurde importiert und entspricht Kategorien in aio*',
    xeroIntegration: [
      'Sie sind zur Zeit nicht mit Xero verbunden.',
      'Bitte drücken Sie den Knopf und geben Sie Ihre Xero Zugangsdaten ein, um aio* Zugang zu gewähren.',
      'Der Kontenplan von Xero wird importiert und als neue Kategorien in aio* hinzugefügt.'
    ],
    xeroNotConnected: [
      'Sie sind noch nicht mit Xero verbunden. Bitte navigieren Sie zu \'@:title.xeroIntegration\' in',
      '\'@:menu.company\'',
      'um die Verbindung herzustellen.'
    ],
    xeroReport: 'Nur Karten-Transaktionen, die noch nicht nach Xero exportiert wurden, werden erfasst.'
  },
  title: {
    addCard: 'Neue Zahlungskarte hinzufügen',
    adminContact: 'Admin Kontaktdetails',
    balanceAvailable: '{budget} ({amount} verfügbar)',
    budgetTransfer: 'Budgettransfer',
    budgetSettings: 'Budget Einstellungen',
    cardStatus: {
      title: 'Kartenstatus: <b>{status}</b>',
      pending: 'ausstehend',
      Active: 'aktiv',
      Cancelled: 'storniert',
      Expired: 'veraltet',
      Lost: 'verloren',
      Stolen: 'gestohlen',
      Suspended: 'suspendiert',
      undefined: ''
    },
    cardTransfer: 'Von Karte überweisen',
    currentOfTotal: '{current} von {total}',
    company: 'Organisation',
    companyInfo: 'Organisationsdetails',
    createBudget: 'Budget erstellen',
    dateRange: 'Zeitraum',
    floatTransfer: 'Banküberweisung',
    guides: 'Hilfsmittel',
    help: 'Hilfe',
    info: 'Info',
    invitedOn: 'Einladung gesendet am {date}',
    inviteUsers: 'Nutzer einladen',
    invitedUsers: 'Eingeladene Nutzer',
    makeRequest: 'Neue Geld-Anfrage',
    manage: 'Verwalten',
    manageBudget: '{budget} verwalten',
    manageRequests: 'Anfragen verwalten',
    myCard: 'Meine Karte',
    myRequests: 'Meine Anfragen',
    myTransactions: 'Meine Ausgaben',
    noCard: '{user} hat noch keine aio* Karte.',
    noPreview: 'Keine Vorschau',
    noTransaction: 'Keine Transaktionen',
    or: 'oder',
    overview: 'Übersicht',
    pageNotFound: 'Seite nicht gefunden',
    paymentDetails: 'Zahlungsart',
    report: 'Bericht',
    reportFor: 'Bericht für {0}',
    reportIssue: 'Problem melden',
    reportType: 'Typ des Berichts',
    request: 'Keine Anfragen | Eine Anfrage | {count} Anfragen',
    requestDetails: 'Anfragedetails',
    settings: 'Einstellungen',
    spend: 'Ausgaben',
    topUpCard: 'Karte aufladen',
    transactionDetails: 'Transaktionsdetails',
    unclassifiedExpenses: 'Unklassifizierte Ausgaben',
    uploadedOn: 'hochgeladen am {date}',
    userCard: '{user}\'s Karte',
    userDetails: 'Nutzerdetails',
    visibility: 'Sichtbar für Nutzer',
    welcome: 'Willkommen bei aio*',
    xeroIntegration: 'Integration mit Xero',
    your: 'Ihrer'
  },
  validation: {
    amount: 'Bitte den Betrag eingeben.',
    chooseBudget: 'Bitte ein Budget auswählen.',
    chooseUser: 'Bitte einen Nutzer auswählen.',
    dateRange: 'Bitte einen korrekten Zeitraum wählen.',
    destinationBudget: 'Bitte Ziel-Budget auswählen.',
    email: 'Bitte eine korrekte Email-Addresse eingeben.',
    managers: 'Bitte mindestens einen Manager für dieses Budget auswählen.',
    name: 'Bitte einen Namen angeben.',
    originBudget: 'Bitte Ausgangs-Budget auswählen.',
    reason: 'Bitte Grund für Anfrage angeben.',
    users: 'Bitte Nutzer auswählen, die Zugang zu diesem Budget erhalten.'
  },
}
